import React, { useContext, useState, useEffect, useCallback } from 'react';
import { LayerContext } from '../LayerContext';
import { MapContext } from '../MapContext';
import { Drawer } from '@mui/material';
import { navbarHeight } from '../../config';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Inspector, MouseHover } from './Inspector';

function InspectDrawer({ isOpen, onClose, layerProps }) {

  const { layers } = useContext(LayerContext);
  const [factorLayers, setFactorLayers] = useState([]);
  const [layer, setLayer] = useState(null);
  const { map } = useContext(MapContext);
  const [init, setInit] = useState(false);

  useEffect(() => {
    // filter Factor layers
    const factorLayers = layers.filter(layer => { if (["hexa","fic","gene","gene_group"].includes(layer.assetType)) return true }).reverse();
    // set default layer
    if (factorLayers.length > 0) {
      // refresh available layers whenever layer list updated
      setFactorLayers(factorLayers);
      // set default layer for the first time
      // reset default layer if it was removed from list
      if (!init) {
        setLayer(factorLayers[0]);
        setInit(true);
      } else {
        if (!layers.includes(layer)) {
          setLayer(factorLayers[0]);
        }
      }
    } else {
      setFactorLayers([]);
      setLayer(null);
    }
  }, [layers])

  const handleLayerTitleChange = (evt) => {
    const selectedLayer = factorLayers.find(obj => { return obj.id === evt.target.value });
    setLayer(selectedLayer);
  }

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={onClose}
      variant="persistent"
      PaperProps={{
        style: {
          width: '400px',
          top: navbarHeight
        },
      }}
    >
      {/* Place the content of GeneListDrawer here */}
      <Box sx={{ minWidth: 120, my: '2rem', mx: '1rem' }}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Select Layer</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={layer?.id || ''}
            label="Select Layer"
            onChange={handleLayerTitleChange}
          >
            {factorLayers.map(layer => (
              <MenuItem key={layer.id} value={layer.id}>[{layer.assetType.replace("_", " ")}] {layerProps.find(l => l.layerId === layer.id).layerTitle}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Inspector map={map} isOpen={isOpen} layer={layer} />
      <MouseHover map={map} isOpen={isOpen} layer={layer} />
    </Drawer>
  );
}

export default InspectDrawer;

